// Runtime config is injected at deploy time as /config.json (see the CDK
// BucketDeployment). Fetched once at startup so the SPA can be repointed without a
// rebuild. Falls back to "/api" (same-origin under CloudFront) when absent.

let cached = null;

export async function loadConfig() {
  if (cached) return cached;
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    cached = res.ok ? await res.json() : {};
  } catch {
    cached = {};
  }
  if (!cached.apiBaseUrl) cached.apiBaseUrl = '/api';
  return cached;
}

export function apiBase() {
  return (cached && cached.apiBaseUrl) || '/api';
}

// PompaBooking embed (NTAI-EMB-03). Off unless config.json says `"embedEnabled": true`;
// a parent page must be listed in `embedParents` (exact origins) to talk to /embed.
export const DEFAULT_EMBED_PARENTS = ['https://booking.pompaprogram.com'];
const ORIGIN_RE = /^(https:\/\/[a-z0-9.-]+(:\d+)?|http:\/\/localhost(:\d+)?)$/i;

export function embedSettings(cfg = cached) {
  const c = cfg || {};
  const parents = Array.isArray(c.embedParents)
    ? c.embedParents.filter((o) => typeof o === 'string' && ORIGIN_RE.test(o))
    : DEFAULT_EMBED_PARENTS;
  return { enabled: c.embedEnabled === true, parents };
}
